<ng-container *ngIf="writingBusinessData">
    <div class="d-block vo-central-content vo-body-regular-14 p-30">
        <div class="pb-30">
            {{ referenceDataLabels.RegisteredForProposition | localizeLabel }} <b class="vo-body-bold-14">{{writingBusinessData.PropositionName}}</b>
        </div>
        <div class="pb-30">
            {{ writingBusinessData.DescriptionText }} {{ writingBusinessData.RegistrationText }}
        </div>
        <div>
            {{ referenceDataLabels.BoiInfo | localizeLabel }}
        </div>
    </div>
</ng-container>